// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__db9B5","safeAppContainer":"styles_safeAppContainer__bgKsd"};